var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sm-text',{attrs:{"text":_vm.text,"format":_vm.format,"color":"black"}}),(!_vm.isRequired)?_c('sm-text',{attrs:{"text":"（任意）","format":_vm.format,"color":"black"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }